import { createSlice } from "@reduxjs/toolkit";

type initialStateType = {
  user: Object | null;
  isLoadingPrice: boolean;
  isLoadingUser: boolean;
  errors: {};
  addAddress: {};
  createUser: {};
  addOrder: {};
  orderDetail: Object | null;
  isLoading: boolean;
};

export const initialState: initialStateType = {
  user: null,
  isLoadingPrice: false,
  isLoadingUser: false,
  errors: {},
  addAddress: {},
  createUser: {},
  addOrder: {},
  orderDetail: {},
  isLoading: false,
};

const OrderSlice = createSlice({
  name: "Order",
  initialState,
  reducers: {
    setIsLoading: (state: initialStateType, action: { payload: boolean }) => {
      state.isLoading = action.payload;
    },
    setIsLoadingPrice: (
      state: initialStateType,
      action: { payload: boolean }
    ) => {
      state.isLoadingPrice = action.payload;
    },
    setIsLoadingUser: (
      state: initialStateType,
      action: { payload: boolean }
    ) => {
      state.isLoadingUser = action.payload;
    },
    addAddressSuccess: (state: initialStateType, action: any) => {
      state.addAddress = action.payload;
    },
    addAddressError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null;
    },
    getUserByEmailSuccess: (state: initialStateType, action: any) => {
      state.user = action.payload;
    },
    getUserByEmailError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null;
    },
    createUserSuccess: (state: initialStateType, action: any) => {
      state.createUser = action.payload;
    },
    createUserError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null;
    },
    addOrderSuccess: (state: initialStateType, action: any) => {
      state.addOrder = action.payload;
    },
    addOrderError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null;
    },
    getOrderByIdSuccess: (state: initialStateType, action: any) => {
      state.orderDetail = action.payload;
    },
    getOrderByIdError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null;
    },
  },
});

export default OrderSlice.reducer;
export const {
  setIsLoading,
  setIsLoadingPrice,
  setIsLoadingUser,
  getUserByEmailSuccess,
  getUserByEmailError,
  addAddressSuccess,
  addAddressError,
  createUserSuccess,
  createUserError,
  addOrderSuccess,
  addOrderError,
  getOrderByIdSuccess,
  getOrderByIdError
} = OrderSlice.actions;
